import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'xm-descriptive-modal',
    templateUrl: 'descriptive.html',
    styleUrls: ['descriptive.scss'],
    standalone: false
})

export class DescriptiveModal implements OnInit {
    public data: DescriptiveModalData;
    public isActivityModal: boolean = true;
    public closeAutoFocus: boolean = false;

    private dialogRef: MatDialogRef<DescriptiveModal>;

    constructor(dialogRef: MatDialogRef<DescriptiveModal>, @Inject(MAT_DIALOG_DATA) data: DescriptiveModalData) {
        Object.assign(this, { data, dialogRef });
    }

    public close(action: string): void {
        const response: ModalResponse = {
            close: action === 'close',
            primary: action === 'primary',
            secondary: action === 'secondary'
        };

        this.dialogRef.close(response);
    }

    public ngOnInit(): void {
        this.closeAutoFocus = this.data?.closeAutoFocus;
    }
}
